import { c as _c } from "react/compiler-runtime";
import { tv } from "tailwind-variants";
import { classNames } from "../../utils/classNames";
import { Button } from "../Button";
const toggleButtonVariants = tv({
  base: "hover:bg-bg-additional-1",
  variants: {
    checked: {
      // Override existing button borders
      true: "!border-text-primary bg-bg-additional-1"
    }
  }
});
export function ToggleButton(t0) {
  const $ = _c(11);
  let checked;
  let className;
  let rest;
  if ($[0] !== t0) {
    ({
      className,
      checked,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = checked;
    $[2] = className;
    $[3] = rest;
  } else {
    checked = $[1];
    className = $[2];
    rest = $[3];
  }
  let t1;
  if ($[4] !== checked || $[5] !== className) {
    t1 = classNames(toggleButtonVariants({
      checked
    }), className);
    $[4] = checked;
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== checked || $[8] !== rest || $[9] !== t1) {
    t2 = <Button aria-checked={checked} className={t1} role="checkbox" variant="secondary" {...rest} />;
    $[7] = checked;
    $[8] = rest;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}